<nz-input-group
  class="w-1/2 pb-5"
  nzSearch
  nzSize="large"
  [nzAddOnAfter]="suffixIconButton"
  ><input
    #searchInput
    [(ngModel)]="searchValue"
    type="text"
    nz-input
    placeholder="Suchen Sie nach Bezeichnung, Modul, Ersteller oder Startdatum"
    (input)="onSearch()"
  />
</nz-input-group>
<ng-template #suffixIconButton>
  <button (click)="onSearch()" nz-button nzType="primary" nzSearch>
    <span nz-icon nzType="search"></span>
  </button>
</ng-template>
<nz-table
  *ngIf="!loading"
  #nzTable
  nzSize="middle"
  nzTableLayout="auto"
  [nzData]="displayedProvisionRequests"
  [nzFrontPagination]="true"
  [nzPageIndex]="1"
  [nzPageSize]="50"
  [nzLoading]="loading"
  (nzQueryParams)="onTableQueryParamsChange($event)"
>
  <thead>
    <tr>
      <th
        *ngFor="let column of listOfColumns"
        [nzSortOrder]="column.sortOrder"
        [nzSortFn]="column.sortFn"
        [nzFilters]="column.listOfFilter"
        [nzFilterFn]="column.filterFn"
        [nzShowFilter]="column.showFilter"
      >
        {{ column.name }}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr
      *ngFor="let provisionRequest of nzTable.data"
      (click)="onProvisionClick(provisionRequest)"
      class="clickable-row"
    >
      <td>{{ provisionRequest.bezeichnung }}</td>
      <td>{{ provisionRequest.modul?.bezeichnung ?? 'Kein Modul' }}</td>
      <td>
        {{
          provisionRequest.ersteller.vorname +
            ' ' +
            provisionRequest.ersteller.name
        }}
      </td>
      <td>
        {{
          DateTime.fromISO(provisionRequest.datumVon).toLocaleString() +
            ' - ' +
            DateTime.fromISO(provisionRequest.datumBis).toLocaleString()
        }}
      </td>
      <td>
        <ng-container [ngSwitch]="provisionRequest.status">
          <nz-badge
            *ngSwitchCase="'Aktiv'"
            nzStatus="success"
            nzText="Aktiv"
          ></nz-badge>
          <nz-badge
            *ngSwitchCase="'Ausstehend'"
            nzStatus="processing"
            nzText="Ausstehend"
          ></nz-badge>
          <nz-badge
            *ngSwitchCase="'Beendet'"
            nzStatus="error"
            nzText="Beendet"
          ></nz-badge>
          <nz-badge
            *ngSwitchCase="'Ausgelaufen'"
            nzColor="orange"
            nzText="Ausgelaufen"
          ></nz-badge>
        </ng-container>
      </td>
    </tr>
  </tbody>
</nz-table>

<nz-spin
  *ngIf="loading"
  nzSize="large"
  nzTip="Lade Anfragen..."
  style="padding-top: 50%"
>
</nz-spin>
